const FAMILY_RELATIONSHIPS = [
  "Parent",
  "Child",
  "Spouse / Partner",
  "Sibling",
  "Grandparent",
  "Grandchild",
  "Aunt / Uncle",
  "Niece / Nephew",
  "Cousin",
  "In-law",
  "Friend",
  "Caregiver",
  "Doctor",
  "Helper",
  "Other",
];

export { FAMILY_RELATIONSHIPS };
